import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { toast } from "sonner";

// Anniversaires — SMS de bonne fête automatique (mot de Kru Ralph) + liste des prochains anniversaires.
export function BirthdayCard() {
  const [cfg, setCfg] = useState(null);
  const [up, setUp] = useState(null);
  const [editing, setEditing] = useState(false);
  const [msg, setMsg] = useState("");

  const load = () => {
    api.get("/birthday-sms/config").then((r) => { setCfg(r.data); setMsg(r.data.message); }).catch(() => {});
    api.get("/birthday-sms/upcoming?days=14").then((r) => setUp(r.data)).catch(() => {});
  };
  useEffect(() => { load(); }, []);
  if (!cfg || !up) return null;

  const toggle = async () => {
    const next = !cfg.enabled;
    if (next && !window.confirm("Activer l'envoi automatique ? Chaque jour à 10 h, les élèves actifs dont c'est l'anniversaire recevront le SMS (élève ou parent).")) return;
    try { const { data } = await api.put("/birthday-sms/config", { enabled: next }); setCfg((c) => ({ ...c, ...data })); toast.success(next ? "SMS d'anniversaire automatiques activés 🎂" : "SMS d'anniversaire désactivés"); }
    catch { toast.error("Erreur"); }
  };
  const saveMsg = async () => {
    try { const { data } = await api.put("/birthday-sms/config", { message: msg }); setCfg((c) => ({ ...c, ...data })); setEditing(false); toast.success("Message enregistré"); }
    catch { toast.error("Erreur"); }
  };
  const test = async () => {
    const phone = window.prompt("Numéro pour le SMS test (format +1819…) :", "+18195278489");
    if (!phone) return;
    try { await api.post("/birthday-sms/test", { phone }); toast.success(`SMS test envoyé au ${phone}`); }
    catch (e) { toast.error(e.response?.data?.detail || "Erreur"); }
  };
  const today = up.birthdays.filter((b) => b.in_days === 0);

  return (
    <div className="rounded-2xl border border-pink-500/30 bg-pink-500/5 p-5 mb-5" data-testid="birthday-card">
      <div className="flex items-start justify-between gap-3 flex-wrap">
        <div>
          <div className="text-[10px] tracking-[0.3em] text-pink-400 uppercase">Anniversaires</div>
          <h3 className="text-lg font-bold text-zinc-100 mt-0.5">🎂 {today.length ? `${today.length} anniversaire${today.length > 1 ? "s" : ""} aujourd'hui` : "Aucun anniversaire aujourd'hui"} · {up.count} dans les 14 jours</h3>
        </div>
        <div className="flex gap-2 flex-wrap">
          <button onClick={toggle} data-testid="birthday-toggle"
            className={`px-3 py-1.5 rounded-lg text-xs font-bold ${cfg.enabled ? "bg-emerald-600 text-white" : "border border-zinc-700 text-zinc-300"}`}>
            {cfg.enabled ? "● SMS auto : ON (10 h)" : "○ SMS auto : OFF"}
          </button>
          <button onClick={() => setEditing((e) => !e)} data-testid="birthday-edit-btn" className="px-3 py-1.5 rounded-lg border border-zinc-700 text-zinc-300 hover:text-white text-xs">✏️ Message</button>
          <button onClick={test} data-testid="birthday-test-btn" className="px-3 py-1.5 rounded-lg border border-zinc-700 text-zinc-300 hover:text-white text-xs" disabled={!cfg.twilio_configured}>📱 SMS test</button>
        </div>
      </div>
      {editing && (
        <div className="mt-3" data-testid="birthday-editor">
          <textarea value={msg} onChange={(e) => setMsg(e.target.value)} rows={3} data-testid="birthday-message-input"
            className="w-full bg-zinc-950 border border-zinc-700 rounded-lg p-2 text-sm text-zinc-100" />
          <div className="flex gap-2 mt-2 text-xs">
            <button onClick={saveMsg} data-testid="birthday-message-save" className="px-3 py-1.5 rounded-lg bg-pink-600 hover:bg-pink-500 text-white font-bold">💾 Enregistrer</button>
            <button onClick={() => setMsg(cfg.default_message)} className="px-3 py-1.5 rounded-lg border border-zinc-700 text-zinc-300">↺ Texte par défaut</button>
            <span className="text-zinc-500 self-center">Variables : {"{prenom}"} {"{nom}"} {"{age}"}</span>
          </div>
        </div>
      )}
      {up.birthdays.length > 0 && (
        <ul className="mt-3 grid gap-1.5 sm:grid-cols-2 xl:grid-cols-3">
          {up.birthdays.map((b) => (
            <li key={b.contract_id} className={`flex items-center justify-between gap-2 rounded-lg px-3 py-1.5 border ${b.in_days === 0 ? "bg-pink-500/15 border-pink-500/40" : "bg-zinc-900/70 border-zinc-800"}`} data-testid={`birthday-row-${b.contract_id}`}>
              <div className="min-w-0">
                <div className="text-sm font-semibold text-zinc-100 truncate">{b.full_name} <span className="text-zinc-500 font-normal">· {b.age} ans</span></div>
                <div className="text-[11px] text-zinc-400 capitalize">{b.in_days === 0 ? "🎉 Aujourd'hui" : b.in_days === 1 ? "Demain" : `Dans ${b.in_days} jours`} · {b.discipline}</div>
              </div>
              <span className="text-[10px] text-zinc-500">{b.sent_this_year ? "SMS ✓" : !b.has_phone ? "sans tél." : ""}</span>
            </li>
          ))}
        </ul>
      )}
      {up.missing_dob > 0 && <p className="text-[11px] text-zinc-500 mt-3">{up.missing_dob} élève(s) actif(s) sans date de naissance — complète les fiches pour ne rater aucune fête.</p>}
    </div>
  );
}
